import { render, staticRenderFns } from "./BalanceForm.vue?vue&type=template&id=874135e2&scoped=true&"
import script from "./BalanceForm.vue?vue&type=script&lang=js&"
export * from "./BalanceForm.vue?vue&type=script&lang=js&"
import style0 from "./BalanceForm.vue?vue&type=style&index=0&id=874135e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874135e2",
  null
  
)

export default component.exports